import template from './ventajas.component.html';
import angular from 'angular';
import './ventajas.repository';



angular
    .module('Toke')
    .component('appVentajas', {
        template,
        bindings: {
            data: '<'
        },
        controller: VentajasController
    });



VentajasController.$inject = ['ventajasRepository'];

function VentajasController(ventajasRepository) {
    const vm = this;

    vm.ventajas = {};
    vm.listLeft = [];
    vm.listRight = [];

    vm.$onInit = function () {

        const splitList = (data) => {
            if (!data || !Array.isArray(data.list)) return;

            vm.listLeft = data.list.filter(item => item.align === 'left');
            vm.listRight = data.list.filter(item => item.align === 'right');
        };

        if (vm.data && vm.data.list) {
            vm.ventajas = vm.data;
            splitList(vm.ventajas);
        } else {
            ventajasRepository.getVentajas().then(res => {
                vm.ventajas = res || {};
                splitList(vm.ventajas);

            });
        }
    };
}
